module.exports = __webpack_public_path__ + "static/img/logo_white.fdc7619.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logo_white.png
// module id = hQvu
// module chunks = 60